/**
 * Global force-update gate.
 *
 * Set by the app-updater when the server advertises a `minNativeVersion`
 * higher than the running native app's version. Read by the router guard
 * in routes-user.ts to redirect all navigation to the force-update screen.
 *
 * Stays set until the app restarts or ServerConnect accepts a new server, since
 * the minimum version is per server. The OTA check re-trips it if the new
 * server also requires a newer app.
 */

let _forceUpdateActive = false;

export function setForceUpdateActive(): void {
  _forceUpdateActive = true;
}

export function clearForceUpdateActive(): void {
  _forceUpdateActive = false;
}

export function isForceUpdateActive(): boolean {
  return _forceUpdateActive;
}
